import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../App';
import { api } from './api/api';

// ── SVG Icons ─────────────────────────────────────────────────

const Ico = ({ children }) => (
    <span className="fb-nav-icon">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round">
            {children}
        </svg>
    </span>
);

const IcoSetup = () => (
    <Ico>
        <path d="M12 20h9" />
        <path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
    </Ico>
);

const IcoTestings = () => (
    <Ico>
        <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v11m0 0H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4m-6 0h6" />
    </Ico>
);

const IcoAnalysis = () => (
    <Ico>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
    </Ico>
);

const IcoDrivers = () => (
    <Ico>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Ico>
);

const IcoDriverHistory = () => (
    <Ico>
        <path d="M3 3v18h18" />
        <path d="M7 16l4-4 4 4 4-8" />
    </Ico>
);

const IcoTDHistory = () => (
    <Ico>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Ico>
);

const IcoPitHistory = () => (
    <Ico>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </Ico>
);

const IcoWeather = () => (
    <Ico>
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </Ico>
);

const IcoSponsors = () => (
    <Ico>
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </Ico>
);

const IcoGains = () => (
    <Ico>
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </Ico>
);

const IcoMarket = () => (
    <Ico>
        <path d="M3 3h18v4H3z" />
        <path d="M5 7v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7" />
        <path d="M10 12h4" />
    </Ico>
);

const IcoCalendar = () => (
    <Ico>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </Ico>
);

const IcoAdmin = () => (
    <Ico>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </Ico>
);

const IcoAnalysisResults = () => (
    <Ico>
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </Ico>
);

const IcoVpn = () => (
    <Ico>
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </Ico>
);

const IcoGroupSpending = () => (
    <Ico>
        <rect x="1" y="4" width="22" height="16" rx="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
    </Ico>
);

const IcoSettings = () => (
    <Ico>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </Ico>
);

const IcoLogout = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);

// ── Nav items ──────────────────────────────────────────────────

const NAV_ITEMS = [
    { path: '/setup', label: 'Setup', Icon: IcoSetup, roles: null },
    { path: '/testings', label: 'Testings', Icon: IcoTestings, roles: null },
    { path: '/race-analysis', label: 'Race Analysis', Icon: IcoAnalysis, roles: null },
    { path: '/driver-history', label: 'Driver History', Icon: IcoDriverHistory, roles: null },
    { path: '/td-history', label: 'TD History', Icon: IcoTDHistory, roles: null },
    { path: '/pit-history', label: 'Pit Stops', Icon: IcoPitHistory, roles: null },
    { path: '/weather', label: 'Weather', Icon: IcoWeather, roles: null },
    { path: '/sponsors', label: 'Sponsors', Icon: IcoSponsors, roles: null },
    { path: '/driverhistory', label: 'Driver & TD', Icon: IcoDrivers, roles: null },
    { path: '/season-gains', label: 'Season Gains', Icon: IcoGains, roles: ['ADMIN', 'UPDATER', 'FORCE_ONE', 'BRUTE_FORCE'] },
    { path: '/market', label: 'Market', Icon: IcoMarket, roles: null },
    { path: '/season-planner', label: 'Season Planner', Icon: IcoCalendar, roles: ['ADMIN', 'FORCE_ONE', 'BRUTE_FORCE', 'MIDLAND'] },
    { path: '/analysis-results', label: 'Analysis Results', Icon: IcoAnalysisResults, roles: ['ADMIN'] },
    { path: '/group-spending', label: 'Group Spending', Icon: IcoGroupSpending, roles: ['ADMIN', 'FORCE_ONE'] },
    { path: '/vpn', label: 'VPN', Icon: IcoVpn, roles: ['ADMIN'] },
    { path: '/admin', label: 'Admin', Icon: IcoAdmin, roles: ['ADMIN', 'UPDATER'] },
    { path: '/settings', label: 'Settings', Icon: IcoSettings, roles: null },
];

// ── Component ──────────────────────────────────────────────────

const Navbar = ({ onLogout, isOpen, onNavClick }) => {
    const { apiRequests, userRole, visibleSections } = useContext(AuthContext);
    // Admin-controlled visibility matrix is the source of truth once loaded;
    // until then (null) fall back to the built-in role lists.
    const visibleItems = NAV_ITEMS.filter(({ path, roles }) =>
        visibleSections != null
            ? (userRole === 'ADMIN' || visibleSections.includes(path))
            : (!roles || roles.includes(userRole)));

    const [pendingHolidayCount, setPendingHolidayCount] = useState(0);
    useEffect(() => {
        if (!userRole || userRole === 'GUEST') { setPendingHolidayCount(0); return; }
        let cancelled = false;
        api.get('/holidays/pending')
            .then(res => { if (!cancelled) setPendingHolidayCount((res.data || []).length); })
            .catch(() => { if (!cancelled) setPendingHolidayCount(0); });
        return () => { cancelled = true; };
    }, [userRole]);
    return (
        <nav className={`fb-sidebar${isOpen ? ' fb-sidebar--open' : ''}`}>
            {/* Brand */}
            <div className="fb-brand">
                <div className="fb-brand-mark">
                    <div className="fb-brand-dot">F</div>
                    <div>
                        <div className="fb-brand-name">FOBASE</div>
                        <div className="fb-brand-sub">super tool, you know...</div>
                    </div>
                </div>
            </div>

            {/* Nav links */}
            <div className="fb-nav">
                <div className="fb-nav-section">Navigation</div>
                {visibleItems.map(({ path, label, Icon }) => (
                    <NavLink
                        key={path}
                        to={path}
                        className={({ isActive }) =>
                            'fb-nav-item' + (isActive ? ' active' : '')
                        }
                        onClick={onNavClick}
                    >
                        <Icon />
                        {label}
                        {path === '/settings' && pendingHolidayCount > 0 && (
                            <span className="fb-nav-badge">{pendingHolidayCount}</span>
                        )}
                    </NavLink>
                ))}
            </div>

            {/* Footer */}
            <div className="fb-sidebar-footer">
                {apiRequests !== null && (
                    <div style={{
                        padding: '8px 16px',
                        fontSize: 11,
                        color: apiRequests < 20 ? '#ef4444' : apiRequests < 50 ? '#f59e0b' : 'var(--c-text-muted)',
                        fontWeight: 500,
                        borderTop: '1px solid var(--c-border)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6,
                    }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                        </svg>
                        GPRO API: {apiRequests} left
                    </div>
                )}
                <button className="fb-logout-btn" onClick={onLogout}>
                    <IcoLogout />
                    Sign out
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
